(()=>{
  const ROOT='[data-ftc-free-shipping]';
  let timer=null;
  let lastCart=null;

  function formatDh(cents){
    const value=Math.max(0,Number(cents)||0)/100;
    const whole=Math.abs(value-Math.round(value))<0.00001;
    return new Intl.NumberFormat('fr-FR',{minimumFractionDigits:whole?0:2,maximumFractionDigits:2}).format(value)+' DH';
  }
  function escapeHtml(value){
    return String(value).replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch]));
  }
  function render(widget,cart){
    const totalCents=Number(cart?.total_price)||0;
    const itemCount=Number(cart?.item_count)||0;
    const threshold=Math.max(0,Number(widget.dataset.thresholdCents)||0);
    const message=widget.querySelector('[data-ftc-free-shipping-message]');
    const fill=widget.querySelector('[data-ftc-free-shipping-fill]');
    const track=widget.querySelector('[data-ftc-free-shipping-track]');
    if(!message||!fill||!track)return;
    const isAnnouncement=widget.dataset.ftcVariant==='announcement';

    if(isAnnouncement && itemCount===0){
      message.innerHTML='<strong>'+escapeHtml(widget.dataset.emptyTemplate||'LIVRAISON GRATUITE')+'</strong>';
      fill.style.width='0%';
      track.classList.add('is-hidden');
      track.setAttribute('aria-valuenow','0');
      widget.classList.remove('is-unlocked');
      return;
    }

    track.classList.remove('is-hidden');
    const unlocked=threshold===0||totalCents>=threshold;
    const percent=threshold===0?100:Math.min(100,Math.max(0,(totalCents/threshold)*100));
    fill.style.width=percent+'%';
    track.setAttribute('aria-valuenow',String(Math.round(percent)));
    widget.classList.toggle('is-unlocked',unlocked);
    if(unlocked){
      message.innerHTML='<span class="ftc-free-shipping__icon ftc-free-shipping__icon--check" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><circle cx="12" cy="12" r="9"/><path d="m8 12.2 2.6 2.6L16.4 9"/></svg></span><strong>'+escapeHtml(widget.dataset.unlockedTemplate||'Livraison gratuite débloquée !')+'</strong>';
    }else{
      const remaining=Math.max(0,threshold-totalCents);
      const text=(widget.dataset.remainingTemplate||'Il vous reste [montant] pour bénéficier de la livraison gratuite').replace('[montant]',formatDh(remaining));
      message.innerHTML='<span class="ftc-free-shipping__icon ftc-free-shipping__icon--truck" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M3 6.5h10.5v9H3z"/><path d="M13.5 10h3.7l2.8 3v2.5h-6.5z"/><circle cx="7" cy="17.5" r="1.75"/><circle cx="17.5" cy="17.5" r="1.75"/><path d="M4.5 9.2h5.2"/><path d="M4.5 12h3.6"/></svg></span><span>'+escapeHtml(text)+'</span>';
    }
  }
  function renderAll(cart){
    lastCart=cart;
    document.querySelectorAll(ROOT).forEach(widget=>render(widget,cart));
  }
  async function fetchCart(){
    try{
      const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
      const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)return;
      renderAll(await response.json());
    }catch(e){}
  }
  function refresh(delay=120){
    clearTimeout(timer);
    timer=setTimeout(fetchCart,delay);
  }

  document.addEventListener('product-added',()=>refresh(80));
  document.addEventListener('cart-change',()=>refresh(80));
  document.addEventListener('click',event=>{
    if(event.target.closest('.js-btn-remove,.btn-remove,.js-qty-minus,.js-qty-plus,[name="add"],.js-add-cart')) refresh(400);
  },true);
  document.addEventListener('change',event=>{
    if(event.target.matches('.js-input-quantity,input[name^="updates"]')) refresh(350);
  },true);

  const observer=new MutationObserver(mutations=>{
    let found=false;
    for(const mutation of mutations){
      for(const node of mutation.addedNodes){
        if(node.nodeType===1&&(node.matches?.(ROOT)||node.querySelector?.(ROOT))){found=true;break;}
      }
      if(found)break;
    }
    if(found){ lastCart?renderAll(lastCart):refresh(0); }
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
  if(document.querySelector(ROOT)) refresh(0);
})();
